import { render, staticRenderFns } from "./ModalShowDomainsTemplateInfo.vue?vue&type=template&id=363f74a6"
import script from "./ModalShowDomainsTemplateInfo.vue?vue&type=script&lang=js"
export * from "./ModalShowDomainsTemplateInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports